import { RootState } from "../../../store";

export const getRelationUsers = (state: RootState) => state.relationUsersReducer.friends;
